var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6506 3.3173C13.0737 2.89423 13.7596 2.89423 14.1827 3.3173C14.5732 3.70783 14.6033 4.32233 14.2728 4.74731L14.1827 4.84937L6.73478 12.2973C6.34426 12.6878 5.72976 12.7178 5.30478 12.3874L5.20272 12.2973L1.8173 8.91187C1.39423 8.4888 1.39423 7.80287 1.8173 7.3798C2.20783 6.98928 2.82233 6.95924 3.24731 7.28968L3.34937 7.3798L5.96875 9.99833L12.6506 3.3173Z",
    fill: "#17B31B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick_green.2232e98d2d2cbcdf0917b4440fa65872.svg";
export { ForwardRef as ReactComponent };